// Spese aggiuntive del preventivo [sc-49299]: senza IVA, al massimo una per
// voce. Stanno sul preventivo come shipping_cost, delivery_cost e
// packaging_cost (null = assente), come nell'API (utils/spese.js).

export const VOCI_SPESA = [
  { campo: "shipping_cost", label: "Spedizione" },
  { campo: "delivery_cost", label: "Consegna" },
  { campo: "packaging_cost", label: "Imballo" },
];

const vuoto = (v) => v === null || v === undefined || String(v).trim() === "";
const numero = (v) => Number(String(v).replace(",", "."));

/** Le tre spese di un preventivo, per il form: null se assente. */
export function speseDaPreventivo(q = {}) {
  return Object.fromEntries(
    VOCI_SPESA.map(({ campo }) => [
      campo,
      vuoto(q?.[campo]) || !(Number(q[campo]) > 0) ? null : String(q[campo]),
    ])
  );
}

/**
 * Errore della voce spuntata, o null. `null` = voce non spuntata; stringa
 * vuota = spuntata senza importo.
 */
export function erroreSpesa(valore) {
  if (valore === null || valore === undefined) return null;
  if (vuoto(valore)) return "Scrivi l'importo.";
  const n = numero(valore);
  if (!Number.isFinite(n) || n <= 0) return "L'importo deve essere più di 0.";
  return null;
}

/** Prima spesa non valida del form (con la voce), o null. */
export function primoErroreSpese(form = {}) {
  for (const { campo, label } of VOCI_SPESA) {
    const errore = erroreSpesa(form[campo]);
    if (errore) return `${label}: ${errore}`;
  }
  return null;
}

/** Valori da mandare all'API: numero o null per ogni voce. */
export function speseDaMandare(form = {}) {
  return Object.fromEntries(
    VOCI_SPESA.map(({ campo }) => [
      campo,
      vuoto(form[campo]) ? null : Math.round(numero(form[campo]) * 100) / 100,
    ])
  );
}

/** Righe delle spese presenti: { label, amount }, nell'ordine delle voci. */
export function righeSpese(q = {}) {
  return VOCI_SPESA.filter(({ campo }) => Number(q?.[campo]) > 0).map(
    ({ campo, label }) => ({ label, amount: Number(q[campo]) })
  );
}

/** Somma delle spese di un preventivo. */
export function totaleSpese(q = {}) {
  const somma = righeSpese(q).reduce((t, r) => t + r.amount, 0);
  return Math.round(somma * 100) / 100;
}
